import React, { useEffect } from 'react';
import { Box, TextField, Autocomplete } from '@mui/material';
import { FULL_PERMISSION } from '../../constants/Constant';
// import Helper from '../../utility/helper';
// import ApiHelper from '../../utility/ApiHelper';
// import APIURLConstants from '../../config/config';
// import AppConstants from '../../constants/appConstants';

const ParticipantAutoList = (props) =>
{
    // const [participantList, setParticipantList] = React.useState(null);

    // useEffect(() => {
    //     const gEventInfo = Helper.getStorage('eventInfo');
    //     const gUserInfo = Helper.getStorage('userInfo');

    //     if (
    //         Helper.isAdminUser(gUserInfo) ||
    //         (gUserInfo.roles && Helper.isEventAdmin(gUserInfo))
    //     ) {
    //         ApiHelper.get(
    //             APIURLConstants.GET_EVENT_PARTICIPANTS(gEventInfo.eventID)
    //         ).then((res) => {
    //             if (res.data) {
    //                 const participants = res.data.filter(
    //                     (participant) =>
    //                         AppConstants.EVENT_ROLES_VALUES.indexOf(
    //                             participant.roleName
    //                         ) == -1
    //                 );
    //                 setParticipantList(participants);
    //             }
    //         });
    //     }
    //     // eventInfo.set(gEventInfo);
    //     // userInfo.set(gUserInfo);
    // }, []);
    const [participantObj, setParticipantObj] = React.useState(null);
    useEffect(()=> {
        if (props.participantID && participantObj == null && props.participantList) {
            const partcipate = props.participantList.find((item) => item.userID === props.participantID);
            setParticipantObj(partcipate);
        }
        else {
            setParticipantObj(null);
        }
    }, [props]);

    return (
        <>
            {props.participantList ? (
                <Autocomplete
                    id="participant-autolist"
                    size="small"
                    options={props.participantList}
                    getOptionLabel={(option) => option.name}
                    renderOption={(props, option) => (
                        <Box component="li" {...props}>
                            {option.name}
                        </Box>
                    )}
                    value={props.participant ? props.participant : participantObj}
                    onChange={(event, newValue) =>
                    {
                        props.setParticipant(newValue);
                    }}
                    // defaultValue={[top100Films[1]]}
                    renderInput={(params) => (
                        <TextField {...params} label="Participant"
                            error={props.error}
                            helperText={props.errorText} />
                    )}
                    disabled={
                        props.modPermission == FULL_PERMISSION ? props.disableParticipant ? true : false : true}
                />
            ) : null}
        </>
    );
};
export default ParticipantAutoList;
